(function () {
  'use strict';

  var STORAGE_KEY = 'sucursal_store';
  var GIFT_CARD_TITLE = 'tarjetas de regalo';
  var GIFT_CARD_HANDLE = 'tarjetas-de-regalo';

  function getState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  // ── CONFIRMACIÓN DE SUCURSAL ──────────────────────────────────
  // La sucursal por defecto (Bogotá / LA 95) se siembra sin intervención del
  // usuario, así que el primer add-to-cart abre el selector para que confirme
  // o cambie de tienda. Una vez confirmada —da igual si dejó LA 95 o eligió
  // otra— `confirmado` queda en true y no se vuelve a preguntar.
  function estaConfirmada() {
    if (window.SucursalSelector && typeof window.SucursalSelector.isConfirmado === 'function') {
      return window.SucursalSelector.isConfirmado();
    }

    var state = getState();
    return !!(state && state.id && state.confirmado);
  }

  function abrirSelector() {
    if (window.SucursalSelector && typeof window.SucursalSelector.open === 'function') {
      window.SucursalSelector.open();
      return;
    }

    document.dispatchEvent(new CustomEvent('sucursal:open-selector'));
  }

  // Espera a que el usuario confirme en el modal. Resuelve true si confirmó,
  // false si cerró el modal sin confirmar (ahí el add-to-cart se cancela).
  function esperarConfirmacion() {
    return new Promise(function (resolve) {
      var overlay = document.getElementById('sucursal-overlay');
      var resuelto = false;

      function limpiar() {
        document.removeEventListener('sucursal:changed', onConfirmado);
        if (observer) observer.disconnect();
      }

      function onConfirmado() {
        if (resuelto) return;
        resuelto = true;
        limpiar();
        resolve(true);
      }

      // El modal se cierra quitando .is-open; no emite evento propio de cierre.
      var observer = null;

      if (overlay) {
        observer = new MutationObserver(function () {
          if (resuelto) return;
          if (overlay.classList.contains('is-open')) return;

          // Cerrado: puede ser por confirmación (sucursal:changed llega en el
          // mismo tick) o por abandono. Un turno de margen lo desambigua.
          setTimeout(function () {
            if (resuelto) return;
            resuelto = true;
            limpiar();
            resolve(estaConfirmada());
          }, 50);
        });

        observer.observe(overlay, { attributes: true, attributeFilter: ['class'] });
      }

      document.addEventListener('sucursal:changed', onConfirmado);

      abrirSelector();
    });
  }

  // ── EXCEPCIÓN TARJETAS DE REGALO ──────────────────────────────
  function normalizarTexto(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function esTarjetaRegaloProducto(producto) {
    if (!producto) return false;

    var titulo = normalizarTexto(
      producto.title ||
      producto.productTitle ||
      producto.nombre ||
      producto.name
    );

    var handle = normalizarTexto(producto.handle).replace(/\s+/g, '-');

    return titulo === GIFT_CARD_TITLE || handle === GIFT_CARD_HANDLE;
  }

  function elementoEsTarjetaRegalo(elemento) {
    if (!elemento) return false;

    var link = elemento.matches && elemento.matches('a[href*="/products/"]')
      ? elemento
      : elemento.querySelector && elemento.querySelector('a[href*="/products/"]');

    if (link) {
      var href = link.getAttribute('href') || '';
      var match = href.match(/\/products\/([^/?#]+)/i);
      if (match && normalizarTexto(match[1]).replace(/\s+/g, '-') === GIFT_CARD_HANDLE) {
        return true;
      }
    }

    var titleEl = elemento.querySelector && elemento.querySelector(
      '[data-product-title], .product-card__title, .product-card__name, .card-product__title, .product__title, h1'
    );

    if (titleEl && normalizarTexto(titleEl.textContent) === GIFT_CARD_TITLE) {
      return true;
    }

    return false;
  }

  function esTarjetaRegaloDesdePagina(contexto) {
    // PDP: el handle es la comprobación más fiable antes de validar sucursal.
    var pathMatch = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    if (pathMatch && normalizarTexto(pathMatch[1]).replace(/\s+/g, '-') === GIFT_CARD_HANDLE) {
      return true;
    }

    if (contexto) {
      if (elementoEsTarjetaRegalo(contexto.card)) return true;
      if (elementoEsTarjetaRegalo(contexto.form)) return true;
    }

    return false;
  }

  function obtenerContextoProducto(variantId) {
    var form = null;
    var card = null;
    var productId = null;

    if (variantId) {
      var escapedVariantId = String(variantId).replace(/"/g, '\\"');

      var variantInput =
        document.querySelector(
          'form[data-type="add-to-cart-form"] input[name="id"][value="' + escapedVariantId + '"]'
        ) ||
        document.querySelector(
          'form[action*="/cart/add"] input[name="id"][value="' + escapedVariantId + '"]'
        );

      if (variantInput) {
        form = variantInput.closest('form');
      }
    }

    // Fallback al comportamiento anterior.
    if (!form) {
      form = document.querySelector('form[data-type="add-to-cart-form"]');
    }

    if (form) {
      card = form.closest('[data-product-id]');
      if (card) productId = card.dataset.productId;
    }

    if (!productId) {
      var pdpEl = document.querySelector('[data-product-id]');
      if (pdpEl) {
        productId = pdpEl.dataset.productId;
        if (!card) card = pdpEl;
      }
    }

    return {
      form: form,
      card: card,
      productId: productId
    };
  }

  // ── MODAL DE ADVERTENCIA ──────────────────────────────────────
  function crearModal() {
    var existing = document.getElementById('sucursal-atc-modal');
    if (existing) return existing;

    var modal = document.createElement('div');
    modal.id = 'sucursal-atc-modal';
    modal.innerHTML = [
      '<div class="satc-overlay">',
        '<div class="satc-box">',
          '<button class="satc-close" id="satc-close">&#10005;</button>',
          '<div class="satc-icon">&#9888;</div>',
          '<h3 class="satc-title" id="satc-title"></h3>',
          '<p class="satc-body" id="satc-body"></p>',
          '<div class="satc-actions">',
            '<button class="satc-btn satc-btn--secondary" id="satc-btn-cambiar">',
              'Cambiar tienda',
            '</button>',
            '<button class="satc-btn satc-btn--primary" id="satc-btn-ok">',
              'Entendido',
            '</button>',
          '</div>',
        '</div>',
      '</div>'
    ].join('');

    document.body.appendChild(modal);

    modal.querySelector('#satc-close').addEventListener('click', cerrarModal);
    modal.querySelector('#satc-btn-ok').addEventListener('click', cerrarModal);
    modal.querySelector('#satc-btn-cambiar').addEventListener('click', function () {
      cerrarModal();
      document.dispatchEvent(new CustomEvent('sucursal:open-selector'));
    });

    modal.querySelector('.satc-overlay').addEventListener('click', function (e) {
      if (e.target === this) cerrarModal();
    });

    return modal;
  }

  function mostrarModal(tipo, datos) {
    var modal = crearModal();
    var title = document.getElementById('satc-title');
    var body  = document.getElementById('satc-body');

    if (tipo === 'sin_sucursal') {
      title.textContent = 'Selecciona una tienda primero';
      body.textContent  = 'Para agregar productos al carrito debes seleccionar la ciudad y tienda desde donde quieres recibir tu pedido.';
    } else if (tipo === 'sin_stock') {
      title.textContent = 'Producto agotado en esta tienda';
      body.textContent  = '"' + datos.nombre + '" no tiene stock disponible en ' + datos.sucursal + '. Intenta con otra tienda.';
    } else if (tipo === 'stock_insuficiente') {
      title.textContent = 'Stock insuficiente';
      body.textContent  = 'Solo hay ' + datos.disponible + ' unidad' + (datos.disponible !== 1 ? 'es' : '') + ' disponible' + (datos.disponible !== 1 ? 's' : '') + ' en ' + datos.sucursal + '. Estás intentando agregar ' + datos.cantidad + '.';
    }

    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function cerrarModal() {
    var modal = document.getElementById('satc-atc-modal');
    if (!modal) modal = document.getElementById('sucursal-atc-modal');
    if (modal) modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  // ── VALIDAR STOCK ─────────────────────────────────────────────
  function validarStock(variantId, productId, cantidad) {
    var state = getState();
    if (!state || !state.id) return Promise.resolve({ ok: false, tipo: 'sin_sucursal' });

    return fetch(
      'https://sioconn.dislicores.com/poligonos/inventory?locationId=' +
      encodeURIComponent(state.id) +
      '&productId=' + productId
    )
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.length) return { ok: true };

        var producto = data[0];

        // Tarjetas de regalo NO dependen del inventario de una sucursal.
        if (esTarjetaRegaloProducto(producto)) {
          return { ok: true };
        }

        var variantGid = 'gid://shopify/ProductVariant/' + variantId;
        var variant = producto.variants.find(function (v) {
          return v.variantId === variantGid;
        });

        if (!variant) return { ok: true };

        if (variant.available <= 0) {
          return {
            ok: false,
            tipo: 'sin_stock',
            datos: {
              nombre: producto.handle,
              sucursal: state.nombre,
              disponible: 0
            }
          };
        }

        if (variant.available < cantidad) {
          return {
            ok: false,
            tipo: 'stock_insuficiente',
            datos: {
              nombre: producto.handle,
              sucursal: state.nombre,
              disponible: variant.available,
              cantidad: cantidad
            }
          };
        }

        return { ok: true };
      })
      .catch(function () {
        return { ok: true };
      });
  }

  // ── INTERCEPTAR FETCH ─────────────────────────────────────────
  var originalFetch = window.fetch;

  window.fetch = function (resource, config) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    var method = (config && config.method || 'GET').toUpperCase();

    if (!url.includes('/cart/add') || method !== 'POST') {
      return originalFetch.apply(this, arguments);
    }

    // Parsear body ANTES de validar sucursal para poder detectar la excepción.
    var body = {};
    try {
      var rawBody = config && config.body;
      if (typeof rawBody === 'string') {
        body = JSON.parse(rawBody);
      } else if (rawBody instanceof FormData) {
        rawBody.forEach(function (val, key) { body[key] = val; });
      } else if (rawBody instanceof URLSearchParams) {
        rawBody.forEach(function (val, key) { body[key] = val; });
      }
    } catch (e) {}

    var variantId = body.id || (body.items && body.items[0] && body.items[0].id);
    var cantidad = parseInt(
      body.quantity ||
      (body.items && body.items[0] && body.items[0].quantity) ||
      1
    );

    var contexto = obtenerContextoProducto(variantId);
    var productId = contexto.productId;

    // Excepción temprana: deja agregar Tarjetas de regalo incluso sin sucursal.
    if (esTarjetaRegaloDesdePagina(contexto)) {
      return originalFetch.apply(this, arguments);
    }

    var state = getState();
    if (!state || !state.id) {
      mostrarModal('sin_sucursal');
      return Promise.reject(new Error('Sin sucursal seleccionada'));
    }

    var args = arguments;

    function continuarAgregado() {
      if (!variantId || !productId) {
        return originalFetch.apply(window, args);
      }

      return validarStock(variantId, productId, cantidad).then(function (resultado) {
        if (!resultado.ok) {
          mostrarModal(resultado.tipo, resultado.datos);
          return Promise.reject(new Error('Sin stock en sucursal seleccionada'));
        }

        return originalFetch.apply(window, args);
      });
    }

    // Sucursal por defecto sin confirmar: abrimos el selector y solo seguimos
    // si el usuario confirma. El stock se valida DESPUÉS, contra la tienda que
    // haya quedado elegida (puede no ser la que estaba al hacer clic).
    if (!estaConfirmada()) {
      // Le avisa a sucursal.js que no recargue al confirmar: el reload
      // cancelaría este add-to-cart antes de que llegue al servidor.
      window.__sucursalPendingAdd = true;

      return esperarConfirmacion()
        .then(function (confirmo) {
          if (!confirmo) {
            return Promise.reject(new Error('Sucursal no confirmada'));
          }

          return continuarAgregado().then(function (resp) {
            // Reload diferido que sustituye al que suprimimos: en PDP/carrito
            // los precios por zona se calculan server-side. Va tras el add
            // para que el producto ya esté dentro al repintar.
            if (!document.querySelector('[data-branch-grid]')) {
              setTimeout(function () { window.location.reload(); }, 300);
            }

            return resp;
          });
        })
        .finally(function () {
          window.__sucursalPendingAdd = false;
        });
    }

    return continuarAgregado();
  };

  // ── ESCUCHAR EVENTO PARA ABRIR SELECTOR ───────────────────────
  document.addEventListener('sucursal:open-selector', function () {
    // Vía openModal() para que precargue ciudad/tienda/envío actuales; el
    // fallback manual solo aplica si sucursal.js aún no expuso su API.
    if (window.SucursalSelector && typeof window.SucursalSelector.open === 'function') {
      window.SucursalSelector.open();
      return;
    }

    var overlay = document.getElementById('sucursal-overlay');
    if (overlay) {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  });

})();
